import { render, staticRenderFns } from "./modalDeleteTag.vue?vue&type=template&id=9004101e&scoped=true"
import script from "./modalDeleteTag.vue?vue&type=script&lang=js"
export * from "./modalDeleteTag.vue?vue&type=script&lang=js"
import style0 from "./modalDeleteTag.vue?vue&type=style&index=0&id=9004101e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9004101e",
  null
  
)

export default component.exports